import React, { useEffect } from 'react';
import { Leaf, Utensils, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';

const OmOs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-0">
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <img 
          src="/images/nature-view.png" 
          alt="GuldBoSund Konference & Event Natur" 
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative z-10 text-center px-4 mt-20">
          <h1 className="text-4xl md:text-6xl font-light text-white uppercase tracking-[0.2em] mb-4">
            OM GULDBOSUND KONFERENCE & EVENT
          </h1>
          <p className="text-white/90 text-lg font-light tracking-wide max-w-2xl mx-auto">
            Hvor naturens ro møder gastronomisk ekspertise
          </p>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-3xl font-light text-[#081f32] uppercase tracking-widest mb-8">VORES FILOSOFI</h2>
              <div className="space-y-6 text-gray-600 font-light leading-relaxed">
                <p>
                  Hos GuldBoSund Konference & Event tror vi på, at de største øjeblikke fortjener de bedste rammer. Vores mission er at skabe en uforglemmelig oplevelse for dig og dine gæster, hvor intet er overladt til tilfældighederne.
                </p>
                <p>
                  Beliggende direkte ud til Guldborgsund, tilbyder vi en unik kombination af moderne faciliteter og vild natur. Her er der plads til både de store armbevægelser og de intime samtaler.
                </p>
                <p>
                  Vores dedikerede team af kokke, tjenere og koordinatorer arbejder hver dag for at sikre, at din fest, dit bryllup eller din konference bliver præcis, som du har drømt om – og mere til.
                </p>
              </div>
            </div>
            <div className="relative">
              <img 
                src="/Kundebilleder/d7525ece-6de0-46c0-b5ff-cc6d065f74aa-1_all_6033.jpg" 
                alt="Gastronomi" 
                className="rounded-3xl shadow-2xl w-full h-[500px] object-cover"
              />
              <div className="absolute -bottom-6 -left-6 bg-[#dab256] text-[#081f32] p-8 rounded-2xl hidden md:block">
                <p className="text-4xl font-light mb-1">100%</p>
                <p className="text-xs uppercase tracking-widest">Dedikeret til kvalitet</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Three Pillars */}
      <section className="py-16 bg-[#081f32] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div className="text-center group">
              <div className="w-16 h-16 bg-[#dab256] rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <Leaf className="text-[#081f32] w-8 h-8" />
              </div>
              <h3 className="text-xl font-light uppercase tracking-widest mb-4">NATUREN</h3>
              <p className="text-gray-300 font-light text-sm leading-relaxed">
                Vores unikke placering giver adgang til storslåede naturoplevelser, der danner den perfekte kulisse for billeder og refleksion.
              </p>
            </div>
            <div className="text-center group">
              <div className="w-16 h-16 bg-[#dab256] rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <Utensils className="text-[#081f32] w-8 h-8" />
              </div>
              <h3 className="text-xl font-light uppercase tracking-widest mb-4">GASTRONOMIEN</h3>
              <p className="text-gray-300 font-light text-sm leading-relaxed">
                Vi anvender de bedste lokale råvarer til at skabe moderne klassikere, der forkæler både øjne og smagsløg.
              </p>
            </div>
            <div className="text-center group">
              <div className="w-16 h-16 bg-[#dab256] rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <Heart className="text-[#081f32] w-8 h-8" />
              </div>
              <h3 className="text-xl font-light uppercase tracking-widest mb-4">SERVICE</h3>
              <p className="text-gray-300 font-light text-sm leading-relaxed">
                Personlig betjening og opmærksomhed på detaljen er kernen i alt, hvad vi foretager os.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-50 text-center">
        <div className="max-w-3xl mx-auto px-4">
          <h2 className="text-3xl font-light text-[#081f32] uppercase tracking-widest mb-6">KLAR TIL AT PLANLÆGGE?</h2>
          <p className="text-gray-600 font-light mb-10">
            Lad os tage en uforpligtende dialog om dit næste arrangement og hvordan vi kan gøre det til noget helt særligt.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/kontakt"
              className="bg-[#dab256] text-[#081f32] px-10 py-4 rounded-full text-sm font-light uppercase tracking-widest hover:bg-[#c4a04a] transition-all"
            >
              KONTAKT OS
            </Link>
            <Link 
              to="/"
              className="border border-[#081f32] text-[#081f32] px-10 py-4 rounded-full text-sm font-light uppercase tracking-widest hover:bg-[#081f32] hover:text-white transition-all"
            >
              SE FORSIDE
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OmOs;
